import * as protectionsTypes from 'protections/actions/protectionsActionTypes.js';

export default function protectionsReducer(state = [], action) {
    switch (action.type) {
        case protectionsTypes.SET_PROTECTIONS:
            return action.protections;

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/protectionsReducer.js